import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Pause({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M16.4005 18C15.9037 18 15.5005 17.328 15.5005 16.5V7.5C15.5005 6.672 15.9037 6 16.4005 6C16.8973 6 17.3005 6.672 17.3005 7.5V16.5C17.3005 17.328 16.8973 18 16.4005 18Z" fill="currentColor" /><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M8.4 18C7.9032 18 7.5 17.328 7.5 16.5V7.5C7.5 6.672 7.9032 6 8.4 6C8.8968 6 9.3 6.672 9.3 7.5V16.5C9.3 17.328 8.8968 18 8.4 18Z" fill="currentColor" /></Svg>;
}
export default Pause;